<script setup lang="ts">

import Headline from "./Components/Headline.vue";
import HeroTestimonial from "./Components/HeroTestimonial.vue";
import WhatYouGet from "./Components/WhatYouGet.vue";
import Privacy from "./Components/Privacy.vue";
import OurPartners from "./Components/OurPartners.vue";

</script>

<template>

    <div>
        <Headline />
        <HeroTestimonial />
        <WhatYouGet />
        <Privacy />
        <OurPartners />
    </div>

</template>